import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage

import eventMediaReducer from './EventMedia/reducer';

import { SET_SELECTED_RESOURCE } from './actions';

const initialState = {
    resourceType: '',
    resourceId: ''
};

function selectedResourceReducer(state = initialState, action) {
    switch(action.type) {
        case SET_SELECTED_RESOURCE:
            return {
                ...action.payload
            };
        default:
            return state;
    }
}

export default combineReducers({
    EventMedia: eventMediaReducer,
    selectedResource: persistReducer({ key: 'scenes/dashboard/selectedResource', storage }, selectedResourceReducer),
});

